import { Injectable } from '@angular/core';
import { UnitService } from './unit.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, map, tap, withLatestFrom } from 'rxjs/operators';
import {
  TransmissionStatus,
  UnitsTransmissionStatus,
  UnitWithTransmissionStatus,
} from '../models/unit-transmission-status';
import { Unit } from '../models/unit';
import { UserIconsService } from 'src/app/profile-config/services/user-icons.service';
import { getDataTransmissionStates } from '../helpers/unit-helper';
@Injectable({
  providedIn: 'root',
})
export class UnitTransmissionStatusService {
  private unitsWithTransmissionStatus$: BehaviorSubject<
    UnitWithTransmissionStatus[]
  >;
  private unitsTransmissionStates$: BehaviorSubject<UnitsTransmissionStatus[]>;
  constructor(
    private unitService: UnitService,
    public iconService : UserIconsService
  ) {
    this.unitsWithTransmissionStatus$ = new BehaviorSubject<
      UnitWithTransmissionStatus[]
    >([]);
    this.unitsTransmissionStates$ = new BehaviorSubject<
      UnitsTransmissionStatus[]
    >(this.toUnitsTransmissionStatus());
    unitService.getUnits
      .pipe(
        map((units) =>
          units.map((unit) => this.toUnitWithTransmissionStatus(unit))
        ),
        tap((_) => this.unitsWithTransmissionStatus$.next(_)),
        withLatestFrom(this.unitsTransmissionStates$),
        map(([units, unitsTransmissionStates]) => {
          let x = unitsTransmissionStates.map((_) => {
            _.unitsTransmissions = units.filter(
              (unit) => unit.transmissionStatusId == _.transmissionStatusId
            );
            _.transmissionTotalUnits = units.length;
            _.transmissionMatchingUnits = _.unitsTransmissions.length;
            return _;
          });
          this.unitsTransmissionStates$.next([...x]);
          return units;
        })
      )
      .subscribe();
  }
  /**
   * @description returns an observer with data from all transmission states with their units
   */
  get getUnitsTransmissionStates() {
    return this.unitsTransmissionStates$.asObservable();
  }
  /**
   * @description returns an observer with data from all the units with their transmission status
   */
  get getUnitsTransmissionStatus() {
    return this.unitsWithTransmissionStatus$.asObservable();
  }

  getUnitWithTransmissionStatus() : UnitWithTransmissionStatus[]{
    return this.unitsWithTransmissionStatus$.getValue();
  }
  // -----Funtions-----
  public getTransmissionStates(): TransmissionStatus[] {
    return getDataTransmissionStates();
  }

  public getTransmissionInfoById(id: string | number): { name: string; color: string, tag : string} {
    const status = this.getTransmissionStates().find(
      (state) => state.transmissionStatusId.toString() === id.toString()
    );

    return status
      ? { name: status.transmissionStatusName, color: status.transmissionStatusColor, tag : status.transmissionStatusTag }
      : { name: 'No definido', color: '#999999', tag : "undefined" };
  }

  private toUnitWithTransmissionStatus(unit: Unit): UnitWithTransmissionStatus {
    let transmissionStatus: any =
      this.getTransmissionStates().find((_) =>
        _.transmissionUnitCondition(unit)
      );
    let transmissionStatusId = transmissionStatus.transmissionStatusId || 0
    let transmissionStatusColor = transmissionStatus.transmissionStatusColor || "#ffff"
    const vehicleId = unit.unitTypeId
    const iconUlr = this.iconService.getIconTransmission(vehicleId, transmissionStatusId.toString())
    let unitTransmissionStatus: UnitWithTransmissionStatus = {
      ...unit,
      tramsmissionIcon : iconUlr,
      transmissionStatusId: transmissionStatusId,
      transmissionStatusColor : transmissionStatusColor
    };
    return unitTransmissionStatus;
  }
  private toUnitsTransmissionStatus(): UnitsTransmissionStatus[] {
    let unitsTransmissionStates: UnitsTransmissionStatus[] = [];
    this.getTransmissionStates().map((transmissionStatus) => {
      const unitsTransmissionStatus: UnitsTransmissionStatus = {
        transmissionTotalUnits: 0,
        transmissionMatchingUnits: 0,
        unitsTransmissions: [],
        transmissionStatusId: 0,
        transmissionStatusName: '',
        transmissionStatusTag: '',
        transmissionStatusDescription: '',
        transmissionIsActive: false,
        transmissionStatusColor: '',
        transmissionUnitCondition: function (unitStatus: Unit): boolean {
          throw new Error('Function not implemented.');
        },
      };
      unitsTransmissionStates.push({
        ...unitsTransmissionStatus,
        ...transmissionStatus,
      });
    });
    return unitsTransmissionStates;
  }
}
